import { render } from "./ExpiredDocuments.vue?vue&type=template&id=3a146a10"
import script from "./ExpiredDocuments.vue?vue&type=script&lang=js"
export * from "./ExpiredDocuments.vue?vue&type=script&lang=js"

import exportComponent from "/Users/giacomo/Developer/tandu/barbera/barberabilance-docs-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__